// 确保使用 REACT_APP_ 前缀来读取环境变量
export const CRMFRONT_URL = process.env.REACT_APP_CRMFRONT_URL;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL; 